import { useStyleRegister } from '@ant-design/cssinjs';
import { PageContainer } from '@ant-design/pro-components';
import { ConfigProvider, theme } from 'antd';
import PropTypes from 'prop-types';
import { useContext } from 'react';

const FullBleedPageContainer = ({ children }) => {
  const { csp, getPrefixCls } = useContext(ConfigProvider.ConfigContext);
  const { hashId, theme: tokenTheme, token } = theme.useToken();
  const prefix = getPrefixCls('pro');

  // PageContainer's local token is absent from its shared style cache key.
  // Scope the override to this shell instead of changing the shared padding rule.
  useStyleRegister(
    {
      hashId,
      layer: { name: 'antd-pro' },
      nonce: () => csp?.nonce,
      path: ['FullBleedPageContainer', prefix],
      theme: tokenTheme,
      token,
    },
    () => ({
      [`.kip-full-bleed-page > .${prefix}-grid-content > .${prefix}-grid-content-children > .${prefix}-page-container-children-container`]:
        { padding: 0 },
    }),
  );

  return (
    <PageContainer className={`kip-full-bleed-page ${hashId}`} pageHeaderRender={false}>
      {children}
    </PageContainer>
  );
};

FullBleedPageContainer.propTypes = { children: PropTypes.node };

export default FullBleedPageContainer;
